<ion-card-header
  class="ion-no-padding ion-padding-horizontal ion-padding-bottom"
>
  <h5>
    <ion-label color="dark">
      <strong
        >{{ 'installations_title' | translate }} ({{
          installationCount()
        }})</strong
      >
    </ion-label>
  </h5>
</ion-card-header>
<ion-card-content>
  @if (hasInstallation()) {
    <div class="installation-table-wrapper">
      <mat-form-field appearance="outline" class="installation-filter">
        <mat-label>{{ 'list_search' | translate }}</mat-label>
        <input
          matInput
          type="text"
          #filterInput
          (input)="applyFilter(filterInput.value)"
        />
      </mat-form-field>
      <div class="installation-table-scroll">
        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          class="mat-elevation-z1 installation-table"
        >
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ 'installation_name' | translate }}
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              (click)="onInstallationClicked(row.id)"
            >
              {{ row.name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ 'list_address' | translate }}
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              (click)="onInstallationClicked(row.id)"
            >
              {{ row.addressLine1 }}
              @if (row.postalCode || row.city) {
                , {{ row.postalCode }} {{ row.city }}
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="owner">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ 'installation_owner' | translate }}
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              (click)="onInstallationClicked(row.id)"
            >
              @if (row.owner; as owner) {
                {{ owner.firstname }} {{ owner.lastname }}
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="added">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ 'installation_added' | translate }}
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              (click)="onInstallationClicked(row.id)"
            >
              {{ formatAddedDate(row.added) }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'installation_actions' | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              @if (getAutoLoginLabel(row); as autoLoginLabel) {
                <button
                  mat-flat-button
                  color="primary"
                  class="auto-login-button"
                  (click)="onAutoLogin(row)"
                >
                  <small>{{ autoLoginLabel | translate }}</small>
                </button>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="installation-row"
          ></tr>
        </table>
      </div>

      <mat-paginator
        [length]="installationCount()"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 25, 100]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  } @else {
    <p class="ion-text-center">
      {{ 'installations_noResult' | translate }}
    </p>
  }
</ion-card-content>
